import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { css } from '@emotion/react';
import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton, Modal } from '@mui/material';

import previewBarBackground from '~/assets/images/iphone-white-bg.webp';
import CouponPreview from '~/components/builder/CouponPreview/CouponPreview';
import VideoPreview from '~/components/builder/VideoPreview/VideoPreview';
import { AppsPreviewScreen } from '~/components/organisms/previewBar/components/apps/AppsPreviewScreen';
import { ImagesPreviewScreen } from '~/components/organisms/previewBar/components/images/ImagesPreviewScreen';
import { ListOfLinksPreviewScreen } from '~/components/organisms/previewBar/components/list-of-links/ListOfLinksPreviewScreen';
import { PdfPreviewScreen } from '~/components/organisms/previewBar/components/pdf/PdfPreviewScreen';
import { SocialMediaPreviewScreen } from '~/components/organisms/previewBar/components/social-media/SocialMediaPreviewScreen';
import { VCardPlusPreviewScreen } from '~/components/organisms/previewBar/components/vcard-plus/VCardPlusPreviewScreen';
import { WebsitePreviewScreen } from '~/components/organisms/previewBar/components/website/WebsitePreviewScreen';
import { Text } from '~/components/ui/text';
import { QR_CODE_TEMPLATE_PARAM_NAME, QRCODE_DYNAMIC_MICROSITE_TYPE } from '~/constants/qr-code';
import useBuilderStore from '~/store/useBuilderStore';
import { COLORS } from '~/styles/colors';

const PreviewsMap = {
  [QRCODE_DYNAMIC_MICROSITE_TYPE.WEBSITE]: () => <WebsitePreviewScreen />,
  [QRCODE_DYNAMIC_MICROSITE_TYPE.PDF]: () => <PdfPreviewScreen />,
  [QRCODE_DYNAMIC_MICROSITE_TYPE.LINKS]: <ListOfLinksPreviewScreen />,
  [QRCODE_DYNAMIC_MICROSITE_TYPE.APP]: () => <AppsPreviewScreen />,
  [QRCODE_DYNAMIC_MICROSITE_TYPE.IMAGES]: () => <ImagesPreviewScreen />,
  [QRCODE_DYNAMIC_MICROSITE_TYPE.VCARD_PLUS]: () => <VCardPlusPreviewScreen />,
  [QRCODE_DYNAMIC_MICROSITE_TYPE.SOCIAL_MEDIA]: () => <SocialMediaPreviewScreen />,
  [QRCODE_DYNAMIC_MICROSITE_TYPE.COUPON]: () => <CouponPreview />,
  [QRCODE_DYNAMIC_MICROSITE_TYPE.VIDEO]: () => <VideoPreview />,
};

export default function MobileBuilderPreviewV2() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const styles = useStyles();

  const { isMobilePreviewOpened, setIsMobilePreviewOpened } = useBuilderStore();

  const templateId = searchParams.get(QR_CODE_TEMPLATE_PARAM_NAME);

  const handleClose = () => setIsMobilePreviewOpened(false);

  return (
    <Modal
      open={isMobilePreviewOpened}
      onClose={handleClose}
      sx={styles.modal}
      slotProps={{
        backdrop: {
          sx: styles.backdrop,
        },
      }}
    >
      <Box sx={styles.container}>
        <IconButton onClick={handleClose} sx={styles.closeIconWrapper}>
          <CloseIcon sx={styles.closeIcon} />
        </IconButton>

        <Text variant="h2" sx={styles.title}>
          {t('createQrStep1:previewTitle')}
        </Text>

        <Box sx={styles.phone}>{PreviewsMap[templateId]?.()}</Box>
      </Box>
    </Modal>
  );
}

const useStyles = () => {
  return {
    container: css`
      width: calc(100dvw - 32px);
      padding: 20px 20px 40px;
      border-radius: 16px;
      background-color: ${COLORS.white};
      display: flex;
      flex-direction: column;
      align-items: center;
    `,
    backdrop: css`
      background-color: #c9c8c84d;
      backdrop-filter: blur(3px);
    `,
    modal: css`
      display: flex;
      align-items: center;
      justify-content: center;
    `,
    closeIcon: css`
      color: ${COLORS.textMain};
    `,
    closeIconWrapper: css`
      margin-left: auto;
    `,
    title: css`
      text-align: center;
      margin-bottom: 24px;
    `,
    phone: css`
      background-image: url(${previewBarBackground});
      width: 278px;
      aspect-ratio: 73 / 150;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      overflow: auto;
      display: flex;
      align-items: center;
    `,
  };
};
